import FormContainer from "@app/components/forms/container/FormContainer";
import { useFormWithSchema } from "@app/components/forms/hooks/useFormWithSchema";
import { InspectorProps } from "@app/components/WidgetStudio/Inspector/contracts/InspectorProps";
import { ConversionCodeSchema } from "@app/components/WidgetStudio/Inspector/inspectors/Marketing/conversionCodeSchema";
import { UtmTagSchema } from "@app/components/WidgetStudio/Inspector/inspectors/Marketing/utmTagSchema";
import { Separator, Button } from "@shortsworks/ui";
import { Suspense, useEffect } from "react";

interface MarketingInspectorProps extends InspectorProps {}
export const MarketingInspector = ({
  defaultFormValues,
  onValueChange,
}: MarketingInspectorProps) => {
  const { customUtm } = defaultFormValues;

  const {
    form: conversionCodeForm,
    schemas: conversionCodeSchemas,
    formValues: conversionCodeFormValues,
  } = useFormWithSchema({
    formSchemas: ConversionCodeSchema,
    mode: "onChange",
    defaultFormValues: {
      conversionCode: defaultFormValues?.conversionCode ?? "",
    },
  });

  const {
    form: utmTagForm,
    schemas: utmTagSchemas,
    formValues: UtmTagFormValues,
  } = useFormWithSchema({
    formSchemas: UtmTagSchema,
    mode: "onChange",
    defaultFormValues: {
      // ...defaultFormValues?.customUtm
      // campaign_id: "",
      // "campaign_source": "",
      // "campaign_medium": "",
      // "campaign_name": ""
    },
  });

  // watchForm의 경우, 이벤트가 중복으로 발생하는 현상 있음
  useEffect(() => {
    return onValueChange({
      conversionCode: conversionCodeFormValues.conversionCode,
    });
  }, [conversionCodeFormValues]);

  useEffect(() => {
    return onValueChange({
      customUtm: UtmTagFormValues,
    });
  }, [UtmTagFormValues]);

  return (
    <div className="flex flex-col gap-4 overflow-scroll">
      <Suspense>
        <FormContainer
          schemas={conversionCodeSchemas}
          form={conversionCodeForm}
        />
        <Separator />
        <FormContainer schemas={utmTagSchemas} form={utmTagForm} />
      </Suspense>
    </div>
  );
};
